import common from "./common.json"

const spanish = {
    "translation": {
        "Common": common,
    }
}

export default spanish